

export const fields = {
  filters: {
    month: null,
    day: null,
  },

  traffic: {
    domain: null,
    url: null,
    browser: null,
    os: null,
    os_version: null,
  },

  query: {
    domain: null,
    url: null,
    query_string: null,
    term: null,
  }
}
